import { render, staticRenderFns } from "./PaystatementDetails.vue?vue&type=template&id=3496c8ef&scoped=true"
import script from "./PaystatementDetails.vue?vue&type=script&lang=ts"
export * from "./PaystatementDetails.vue?vue&type=script&lang=ts"
import style0 from "./PaystatementDetails.vue?vue&type=style&index=0&id=3496c8ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3496c8ef",
  null
  
)

export default component.exports